import Vue from "vue";
import Modal from "./Modal.vue";

const Alert = Vue.extend(Modal);

const alertFun = function(text) {
  const Instance = new Alert({
    data: {
      text,
    },
  });
  let vm = Instance.$mount();
  document.body.appendChild(vm.$el);
  return vm.init();
};

export default {
  install: (Vue) => {
    Vue.prototype.$alert = alertFun;
  },
};
export { alertFun };
